import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CampaignWithSteps } from "components/types";
import { createQuery } from "react-query-kit";
import axios from "../../utils/axios";

export const useCampaigns = createQuery<CampaignWithSteps[]>({
  primaryKey: "campaigns",
  queryFn: async ({ queryKey: [primaryKey] }) => {
    return (await axios.get<CampaignWithSteps[]>(primaryKey)).data;
  },
  suspense: true,
});

export const useCampaignStepMutation = (
  onSuccess?: (data: CampaignWithSteps) => void
) => {
  const queryClient = useQueryClient();

  return useMutation<CampaignWithSteps, Error, { startDate: string }>({
    mutationFn: async (data) => {
      return (await axios.post<CampaignWithSteps>("campaigns", data)).data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["campaigns"], [data]);
      onSuccess?.(data);
    },
  });
};

export const useUpdateCampaignStepMutation = (
  onSuccess?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, { stepId: string; startDate?: string; endDate?: string }>({
    mutationFn: async ({ stepId, startDate, endDate }) => {
      return (await axios.put(`campaigns/steps/${stepId}`, { startDate, endDate })).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
      onSuccess?.();
    },
  });
};

export const useUpdateCampaignMutation = (
  onSuccess?: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, { campaignId: string; startDate?: string; endDate?: string }>({
    mutationFn: async ({ campaignId, startDate, endDate }) => {
      return (await axios.put(`campaigns/${campaignId}`, { startDate, endDate })).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
      onSuccess?.();
    },
  });
};
